export default __webpack_public_path__ + "static/social-1caebae1523730fbf4335865b9ddfd34.png";